var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFallaCorriente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.4 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-falla-corriente") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_21",
    "data-name": 21
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.25,255.12A6.61,6.61,0,0,1,28,246.46L62.24,141.08H6.61a6.62,6.62,0,0,1-5.9-9.6L65.44,3.62A6.6,6.6,0,0,1,71.33,0h67.46a6.6,6.6,0,0,1,5.57,10.16L86.92,100.22h51.87a6.61,6.61,0,0,1,5.32,10.53L39.57,252.43A6.6,6.6,0,0,1,34.25,255.12ZM17.36,127.86h54a6.61,6.61,0,0,1,6.29,8.65L53.15,211.76l72.55-98.33H74.86a6.6,6.6,0,0,1-5.57-10.16l57.44-90H75.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFallaCorriente);
export default __webpack_public_path__ + "static/media/ic-falla-corriente.b030e84e517b0a5dcac6d19c41186ff7.svg";
export { ForwardRef as ReactComponent };